import {
  SUPPLIERSAMOUNTS,
  SUPPLIERSAMOUNTS_SUCCESS,
  SUPPLIERSAMOUNTSDETAIL_SUCCESS,
  SUPPLIERSAMOUNTS_ERROR,
  SUPPLIERSAMOUNTSDETAIL_UNLOAD
} from './SuppliersAmount.actions'

const initialState = {
  data: { chartStructure: [], csvStructure: [] },
  detail: [],
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Suppliers Amount's reducer.
 */
const suppliersAmountReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SUPPLIERSAMOUNTS: {
      return { ...state, fetching: true }
    }
    case SUPPLIERSAMOUNTS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case SUPPLIERSAMOUNTSDETAIL_SUCCESS: {
      return { ...state, detail: payload, fetching: false, fetched: true }
    }
    case SUPPLIERSAMOUNTS_ERROR: {
      return { ...state, error: payload.error }
    }
    case SUPPLIERSAMOUNTSDETAIL_UNLOAD: {
      return { ...state, detail: [], fetching: false, fetched: false }
    }
    default: {
      return state
    }
  }
}

export default suppliersAmountReducer
